import { FC } from 'react';
import { CellContainer, Text } from '@/_components';
import { CellIDProps } from './CellID.types';

export const CellID: FC<CellIDProps> = ({ id }) => {
  return (
    <CellContainer width={64}>
      <Text type="tiny">{id || '-'}</Text>
    </CellContainer>
  );
};
